import React from 'react';
import PropTypes from 'prop-types';
import 'react-dates/initialize';

import SingleDatePicker from './SingleDatePicker';

import {
    renderDayWithQuantity,
    renderCalendarDayWithQuantity
} from './DayContentComponents';

export default class SingleDatePickerWithKey extends React.PureComponent {
    static propTypes = {
        /** Function that takes a moment as a parameter and returns a number */
        getQuantity: PropTypes.func.isRequired
    };

    render() {
        const { getQuantity, getTooltipContent, ...rest } = this.props;

        return (
            <SingleDatePicker
                {...rest}
                renderDayContents={renderDayWithQuantity(getQuantity)}
                renderCalendarDay={renderCalendarDayWithQuantity(getQuantity, getTooltipContent)}
                calendarInfoPosition="bottom"
                renderCalendarInfo={this.renderCalendarInfo} />
        );
    }
}



